var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/demo-images/1.jpg": "e7ad",
	"./assets/demo-images/2.jpg": "bd62",
	"./assets/demo-images/3.jpg": "d2e9",
	"./assets/demo-images/4.jpg": "79ec",
	"./assets/demo-images/5.jpg": "037a",
	"./assets/demo-images/6.jpg": "ccf7",
	"./assets/demo/buscard/1.jpg": "064d",
	"./assets/demo/buscard/2.png": "43d6",
	"./assets/demo/buscard/3.png": "a7f3",
	"./assets/demo/buscard/5.png": "a7b5",
	"./assets/demo/buscard/6.png": "3b37",
	"./assets/demo/carbook/1.png": "f12e",
	"./assets/demo/carbook/2.png": "5131",
	"./assets/demo/carbook/3.png": "e071",
	"./assets/demo/carbook/4.png": "db74",
	"./assets/demo/carbook/5.png": "1cbf",
	"./assets/demo/carbook/6.png": "ccfd",
	"./assets/demo/carbook/7.png": "2d02",
	"./assets/demo/htr/1.png": "86b5",
	"./assets/demo/htr/2.jpg": "007d",
	"./assets/demo/htr/3.png": "8ae1",
	"./assets/demo/htr/4.png": "f459",
	"./assets/demo/htr/5.png": "0cc9",
	"./assets/demo/htr/6.png": "42cb",
	"./assets/demo/htr/7.png": "d230",
	"./assets/demo/htr/8.png": "104a",
	"./assets/demo/htr/9.png": "76a2",
	"./assets/demo/invoice/1.png": "8369",
	"./assets/demo/invoice/2.png": "5f84",
	"./assets/demo/invoice/3.png": "0edb",
	"./assets/demo/invoice/4.png": "c4e8",
	"./assets/demo/invoice/5.png": "568e",
	"./assets/demo/invoice/result/1.png": "2c8c",
	"./assets/demo/invoice/result/2.png": "577d",
	"./assets/demo/invoice/result/3.png": "8ea8",
	"./assets/demo/invoice/result/4.png": "b87a",
	"./assets/demo/invoice/result/5.png": "bcec",
	"./assets/demo/loc/1.jpg": "59de",
	"./assets/demo/loc/2.jpg": "ef10",
	"./assets/demo/loc/3.jpg": "f2e6",
	"./assets/demo/loc/result/1.jpg": "49b2",
	"./assets/demo/loc/result/2.jpg": "bc5d",
	"./assets/demo/loc/result/3.jpg": "8a71",
	"./assets/demo/lpr/1.jpg": "291b",
	"./assets/demo/lpr/2.jpg": "13ba",
	"./assets/demo/lpr/3.jpg": "621e",
	"./assets/demo/lpr/4.jpg": "0b0e",
	"./assets/demo/lpr/5.jpg": "dd28",
	"./assets/demo/lpr/6.jpg": "176a",
	"./assets/htr-demo-images/1.jpg": "b41d",
	"./assets/htr-demo-images/2.jpg": "bb52",
	"./assets/htr-demo-images/3.jpg": "0d3b6",
	"./assets/htr-demo-images/4.jpg": "9b5d",
	"./assets/htr-demo-images/5.jpg": "8ad8",
	"./assets/htr-demo-images/6.jpg": "7058",
	"./assets/htr-images/@_icon.png": "85be",
	"./assets/htr-images/arrow-right.png": "85b2",
	"./assets/htr-images/bg.svg": "94e6",
	"./assets/htr-images/checked.png": "7975",
	"./assets/htr-images/demo_icon.png": "ef66",
	"./assets/htr-images/demo_icon_old.png": "4aeb",
	"./assets/htr-images/facebook.png": "801c",
	"./assets/htr-images/ig.png": "9ad1",
	"./assets/htr-images/logo-old.png": "78be",
	"./assets/htr-images/logo.png": "5df7",
	"./assets/htr-images/main_image_1.png": "fe95",
	"./assets/htr-images/messeger.png": "9c91",
	"./assets/htr-images/tel_icon.png": "b29b",
	"./assets/htr-images/thumbnail_image_1.png": "9c6c",
	"./assets/htr-images/upload_image.png": "0c9a",
	"./assets/htr-images/youtube.png": "ec1f",
	"./assets/images/library-icon.png": "09d1",
	"./assets/images/mic.png": "89b2",
	"./assets/images/mock.png": "b8a3",
	"./assets/images/mock2.jpg": "1d4c",
	"./assets/images/poc-back.png": "5f67",
	"./assets/images/stop.png": "7e25",
	"./assets/images/upload-icon.png": "dd6a",
	"./assets/logo.png": "cf05",
	"./components/HelloWorld": "fdab",
	"./components/HelloWorld.vue": "fdab",
	"./components/ImageComponent": "b3f1",
	"./components/ImageComponent.vue": "b3f1",
	"./components/PocButton": "b06a",
	"./components/PocButton.vue": "b06a",
	"./components/PocLoading": "c996",
	"./components/PocLoading.vue": "c996",
	"./components/PocResult": "6efd",
	"./components/PocResult.vue": "6efd",
	"./components/button/ButtonComponent": "25c4",
	"./components/button/ButtonComponent.vue": "25c4",
	"./components/button/NLPSubmit": "d4ba",
	"./components/button/NLPSubmit.vue": "d4ba",
	"./components/button/RecordButton": "b7f1",
	"./components/button/RecordButton.vue": "b7f1",
	"./components/input/NLPInput": "07b1",
	"./components/input/NLPInput.vue": "07b1",
	"./components/loader/SoundWave": "c528",
	"./components/loader/SoundWave.vue": "c528",
	"./components/loader/StopSoundWave": "0740",
	"./components/loader/StopSoundWave.vue": "0740",
	"./components/radio/NLPRadio": "ed9e",
	"./components/radio/NLPRadio.vue": "ed9e",
	"./components/result/BaseResult": "77a3",
	"./components/result/BaseResult.vue": "77a3",
	"./components/result/HTRResult": "2402",
	"./components/result/HTRResult.vue": "2402",
	"./components/result/NLPResult": "a55d",
	"./components/result/NLPResult.vue": "a55d",
	"./components/result/NLPResultLeft": "fd97",
	"./components/result/NLPResultLeft.vue": "fd97",
	"./components/select/ImageSelect": "937e",
	"./components/select/ImageSelect.vue": "937e",
	"./main": "56d7",
	"./main.js": "56d7",
	"./router": "a18c",
	"./router/": "a18c",
	"./router/index": "a18c",
	"./router/index.js": "a18c",
	"./store": "4360",
	"./store/": "4360",
	"./store/_data_buscard.ts": "9833",
	"./store/_data_carbook.ts": "7293",
	"./store/_data_htr.ts": "5e6c",
	"./store/_data_invoice.ts": "6fcb",
	"./store/_data_loc.ts": "d157",
	"./store/_data_lpr.ts": "d04f",
	"./store/_data_ner.ts": "7d33",
	"./store/_data_summary.ts": "5a95",
	"./store/index": "4360",
	"./store/index.js": "4360",
	"./templates/BaseTemplate": "536a",
	"./templates/BaseTemplate.vue": "536a",
	"./templates/DemoTemplate": "de1e",
	"./templates/DemoTemplate.vue": "de1e",
	"./templates/NerTemplate": "5323",
	"./templates/NerTemplate.vue": "5323",
	"./templates/PocTemplate": "8d22",
	"./templates/PocTemplate.vue": "8d22",
	"./views/BuscardHome": "6edd",
	"./views/BuscardHome.vue": "6edd",
	"./views/EsuHome": "67c9",
	"./views/EsuHome.vue": "67c9",
	"./views/HtrHome": "45a9",
	"./views/HtrHome.vue": "45a9",
	"./views/LprHome": "5c19",
	"./views/LprHome.vue": "5c19",
	"./views/NerHome": "4b85",
	"./views/NerHome.vue": "4b85",
	"./views/NlpHome": "79c9",
	"./views/NlpHome.vue": "79c9",
	"./views/PocHome": "ef92",
	"./views/PocHome.vue": "ef92",
	"./views/SpeechHome": "2afb",
	"./views/SpeechHome.vue": "2afb",
	"./views/SprHome": "743f",
	"./views/SprHome.vue": "743f",
	"./views/TransformerBaseHome": "f837",
	"./views/TransformerBaseHome.vue": "f837",
	"./views/demo/BuscardHome": "425a",
	"./views/demo/BuscardHome.vue": "425a",
	"./views/demo/CarbookHome": "a40c",
	"./views/demo/CarbookHome.vue": "a40c",
	"./views/demo/HtrHome": "5486",
	"./views/demo/HtrHome.vue": "5486",
	"./views/demo/InvoiceHome": "5d2e",
	"./views/demo/InvoiceHome.vue": "5d2e",
	"./views/demo/LocHome": "dc45",
	"./views/demo/LocHome.vue": "dc45",
	"./views/demo/LprHome": "174d",
	"./views/demo/LprHome.vue": "174d",
	"./views/demo/NlpHome": "1aa8",
	"./views/demo/NlpHome.vue": "1aa8",
	"./views/demo/NlpHomeBak": "fde5",
	"./views/demo/NlpHomeBak.vue": "fde5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";